const c = {
  name: "Koala",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,19c-1.1,0-1.9,0.8-2.4,1.5c-0.6,0.8-1,1.8-1.4,2.8c-0.7,2-1.2,4.4-1.2,5.7c0,2.8,2.2,5,5,5s5-2.2,5-5
			c0-1.3-0.5-3.6-1.2-5.7c-0.4-1-0.8-2-1.4-2.8C21.9,19.8,21.1,19,20,19z M17,29c0-0.9,0.4-3.1,1.1-5c0.3-0.9,0.7-1.8,1.1-2.3
			C19.7,21.1,20,21,20,21s0.3,0.1,0.7,0.7c0.4,0.6,0.8,1.4,1.1,2.3c0.7,1.9,1.1,4,1.1,5c0,1.7-1.3,3-3,3C18.3,32,17,30.7,17,29z"/>
		<path class="st0" d="M11,25.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C9.8,24.7,10.3,25.2,11,25.2z"
			/>
		<path class="st0" d="M30.3,24c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C29.7,22.7,30.3,23.3,30.3,24z"
			/>
		<path class="st0" d="M5,2H0V0h5c4.8,0,8.9,3.4,9.8,8c0.7-0.3,1.5-0.5,2.2-0.7V5h2v2c0.3,0,0.7,0,1,0s0.7,0,1,0V5h2v2.3
			c0.8,0.2,1.5,0.4,2.2,0.7c0.9-4.6,5-8,9.8-8h5v2h-5c-4,0-7.4,3-7.9,6.9c2.4,1.3,4.6,3.2,6.4,5.2c0.8,0.9,1.5,1.8,2.1,2.8
			C37.1,15.7,38,14,38,12h2c0,2.7-1.3,5.1-3.4,6.5c0.3,0.6,0.6,1.1,0.9,1.7c0.9,2,1.5,4.1,1.5,5.8c0,2.6-1.3,5-3.4,6.9
			c-2,1.8-4.8,3.3-8.1,4.1c-2,1.8-4.6,3-7.5,3c-2.9,0-5.5-1.1-7.5-3c-3.2-0.9-6.1-2.3-8.1-4.1C2.3,31,1,28.6,1,26
			c0-1.7,0.6-3.7,1.5-5.8c0.3-0.6,0.5-1.1,0.9-1.7C1.3,17.1,0,14.7,0,12h2c0,2,0.9,3.7,2.4,4.8c0.6-0.9,1.3-1.9,2.1-2.8
			c1.8-2,4-3.9,6.4-5.2C12.4,5,9,2,5,2z M3,26c0,1.9,1,3.8,2.7,5.4c1.8,1.6,4.4,3,7.5,3.8l0.3,0.1l0.2,0.2C15.3,37,17.5,38,20,38
			c2.5,0,4.7-1,6.3-2.6l0.2-0.2l0.3-0.1c3.1-0.8,5.7-2.1,7.5-3.8C36,29.8,37,27.9,37,26c0-1.3-0.4-3.1-1.3-5
			c-0.9-1.9-2.1-3.9-3.7-5.7C28.8,11.8,24.6,9,20,9s-8.8,2.8-12,6.4c-1.6,1.8-2.8,3.8-3.7,5.7C3.4,22.9,3,24.7,3,26z"/>
		<path class="st0" d="M36,8h4v2h-4V8z"/>
		<path class="st0" d="M40,4h-4v2h4V4z"/>
		<path class="st0" d="M4,10H0V8h4V10z"/>
		<path class="st0" d="M0,6h4V4H0V6z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Koala
};
